export const url =
  process.env.NODE_ENV === "production"
    ? "https://web3server.bugatticollectionsnft.com"
    : "http://localhost:2000";
